import { z } from "zod";
import {
  notificationTypeSchema,
  subscriptionParametersStringOrArrayRecordSchema,
} from "../_shared";

export const createPlatformSubscriptionPayloadSchema = z.object({
  type: notificationTypeSchema,
  company: z.uuid(),
  parameters: subscriptionParametersStringOrArrayRecordSchema,
});

export type CreatePlatformSubscriptionPayload = z.infer<
  typeof createPlatformSubscriptionPayloadSchema
>;
